<template id='modal_edit_Cfc'>
    <vuestic-modal ref="editarCfc" :cancelClass="'none'" :okClass="'none'" :large='true' @closeEvent="closeModal">
        <!-- Header com logo -->
        <div class="modal-header-custom">
            <img src="/logo.png" alt="NovoCFC" class="modal-logo">
            <h3 class="modal-title">Editar Autoescola</h3>
        </div>

        <div class="modal-body">
            <!-- Seção de busca -->
            <div class="search-section">
                <div class="row">
                    <div class="col-md-3">
                        <InputIconGroup
                            typeInput="text"
                            idInput="cnpj"
                            iconInput="fa-id-card"
                            labelInput="CNPJ"
                            :inputValue="autoescola.cnpj"
                            :inputMask="['##.###.###/####-##']"
                            class="input-highlight"
                        ></InputIconGroup>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="form-control-label">Nome Fantasia</label>
                            <input type="text" class="form-control" placeholder="Nome Fantasia" disabled :value="autoescola.nome_fantasia">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <button type="button" class="btn btn-primary search-btn" @click="getGetranCfc()" :disabled="!btnUpdate">
                            <i class="fa fa-search mr-2"></i> Pesquisar
                        </button>
                    </div>
                </div>
            </div>

            <div class="divider">
                <span>Informações Gerais</span>
            </div>

            <!-- Informações gerais -->
            <div class="row mb-4">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label"><i class="fa fa-building mr-1"></i> Razão Social</label>
                        <input type="text" class="form-control" id='razao_social' placeholder="Razão Social" disabled :value="autoescola.razao_social">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="form-control-label"><i class="fa fa-map mr-1"></i> Endereço</label>
                        <input type="text" class="form-control" id='endereco' placeholder="Endereço" disabled :value='autoescola.endereco'>
                    </div>
                </div>
                <div class="col-md-2">
                    <InputIconGroup
                        typeInput="text"
                        idInput="numero"
                        iconInput="fa-home"
                        labelInput="Número"
                        :inputValue="autoescola.numero"
                    ></InputIconGroup>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-md-4">
                    <InputIconGroup
                        typeInput="text"
                        idInput="email"
                        iconInput="fa-envelope"
                        labelInput="Email"
                        :inputValue="autoescola.email"
                        required
                        class="input-highlight"
                    ></InputIconGroup>
                </div>
                <div class="col-md-3">
                    <InputIconGroup
                        typeInput="text"
                        :inputMask="['(##) ####-####', '(##) # ####-####']"
                        idInput="telefone"
                        iconInput="fa-phone"
                        labelInput="Telefone"
                        :inputValue="autoescola.telefone"
                        required
                        class="input-highlight"
                    ></InputIconGroup>
                </div>
            </div>

            <div class="divider">
                <span>Coordenadas Geográficas</span>
            </div>

            <!-- Coordenadas -->
            <div class="row">
                <div class="col-md-6">
                    <div class="coord-card">
                        <div class="coord-header">
                            <i class="fa fa-map-marker"></i> Coordenadas Principais
                        </div>
                        <div class="coord-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-control-label">Latitude</label>
                                        <input type="text" class="form-control" id='lat' placeholder="Latitude" disabled :value='autoescola.lat'>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-control-label">Longitude</label>
                                        <input type="text" class="form-control" id='lon' placeholder="Longitude" disabled :value='autoescola.lon'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-6">
                    <div class="coord-card">
                        <div class="coord-header">
                            <i class="fa fa-motorcycle"></i> Coordenadas Categoria A
                        </div>
                        <div class="coord-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-control-label">Latitude</label>
                                        <input type="text" class="form-control" id='lat_categoria_a' placeholder="Latitude" disabled :value='autoescola.lat_categoria_a'>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-control-label">Longitude</label>
                                        <input type="text" class="form-control" id='lng_categoria_a' placeholder="Longitude" disabled :value='autoescola.lng_categoria_a'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <slot name="footer">
                <button type="button" class="btn btn-primary update-btn" @click='update()' :disabled="!btnUpdate">
                    <i class="fa fa-refresh mr-2"></i> Atualizar
                </button>
            </slot>
        </div>
    </vuestic-modal>
</template>

<script>
// Manter o script original sem alterações
import InputIconGroup from "@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup";
import urlApi from '@/router/urlApiV2'
export default {
    components: {
      InputIconGroup
    },
    name: 'modal_edit_cfc',
    props: {
        autoescola: Object
    },
    data() {
        return {
            cfc: {
                cnpj: null,
                razao_social: null,
                endereco: null,
                numero: null,
                email: null,
                fone: null,
                lat: null,
                lon: null,
                lat_categoria_a: null,
                lng_categoria_a: null
            },
            btnUpdate: true
        }
    },
    mounted() {
        this.$refs.editarCfc.open()
    },
    methods: {
        closeModal(valor)
        {
            this.$emit('closeModal', false)
        },
        getGetranCfc() {
            let cnpj = (document.getElementById('cnpj').value).replace(/\.|-|[^0-9\.]+/g, '');

            var url = `https://ws.novocfc.com.br/api/autoescolas/${cnpj}`;

            this.$http.get(url).then(response => {
                
                this.$toasted.show( response.body.mensagem, {
                    icon: 'fa-check',
                    position: 'top-right',
                    duration: 5000,
                    fullWidth: false
                })

                const data = response.body.dados[0];

                var telefone = this.organizaTelefone(data.telefone1);
                var cnpj = document.getElementById('cnpj').value;

                document.getElementById('razao_social').value = data.razaoSocial;
                document.getElementById('telefone').value = telefone;
                document.getElementById('cnpj').value = cnpj;
                document.getElementById('email').value = data.email;
                document.getElementById('numero').value = data.numero;
                document.getElementById('lat').value = data.lat;
                document.getElementById('lon').value = data.lon;
                document.getElementById('endereco').value = `${data.logradouro }, ${data.bairro}, ${data.cidade}`;
                document.getElementById('lat_categoria_a').value = data.latCatA;
                document.getElementById('lng_categoria_a').value = data.lonCatA;

            }).catch(erro => {
                this.$toasted.show(erro.body.mensagem, {
                    icon: 'fa-info',
                    position: 'top-right',
                    duration: 5000,
                    fullWidth: false
                })
            })
        },
        organizaTelefone(fone) {
            if (fone.length === 8) {
                return this.foneMask('859'+fone);
            }else {
                return this.foneMask(fone);
            }
        },
        foneMask(fone) {
            var ddd = fone.substr(0, 2);
            var dig = fone.substr(2, 1);
            var ant = fone.substr(3, 4);
            var pos = fone.substr(7, 11);

            var newFone = `(${ddd}) ${dig} ${ant}-${pos}`;
            return newFone;
        },
        update()
        {
            this.btnUpdate  =   false
            this.cfc.cnpj           =   document.getElementById('cnpj').value;
            this.cfc.razao_social   =   document.getElementById('razao_social').value;
            this.cfc.endereco       =   document.getElementById('endereco').value;
            this.cfc.numero         =   document.getElementById('numero').value;
            this.cfc.email          =   document.getElementById('email').value;
            this.cfc.fone           =   document.getElementById('telefone').value;
            this.cfc.lat            =   document.getElementById('lat').value;
            this.cfc.lon            =   document.getElementById('lon').value;
            this.cfc.lat_categoria_a    =   document.getElementById('lat_categoria_a').value
            this.cfc.lng_categoria_a    =   document.getElementById('lng_categoria_a').value

            this.$http.put(urlApi + '/autoescola/atualizar/' + this.autoescola.id_cfc, this.cfc).then(response => {
                // this.$refs.editarCfc.close()
                this.$toasted.show( response.body.mensagem, {
                    icon: 'fa-check',
                    position: 'top-right',
                    duration: 5000,
                    fullWidth: false
                })
                this.$emit('cfcUpdated', response.body.dados)
                this.btnUpdate = true
                this.closeModal(false)
            }).catch(error => {
                this.$toasted.show(error.body.mensagem, {
                    icon: 'fa-times',
                    position: 'top-right',
                    duration: 5000,
                    fullWidth: false
                })
                this.btnUpdate = true
            });
        }
    }
}
</script>

<style scoped>
.modal-header-custom {
    background: #1c2d5a;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 6px 6px 0 0;
}

.modal-logo {
    width: 180px;
    margin-bottom: 10px;
}

.modal-title {
    color: white;
    margin: 10px 0 0;
    font-size: 1.5rem;
    font-weight: 600;
}

.modal-body {
    padding: 25px;
}

.search-section {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.search-btn {
    height: 42px;
    margin-top: 25px;
    border-radius: 6px;
    font-weight: 600;
    transition: all 0.3s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.search-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(28, 45, 90, 0.2);
}

.divider {
    position: relative;
    text-align: center;
    margin: 30px 0;
    height: 1px;
    background: #e9ecef;
}

.divider span {
    position: absolute;
    top: -10px;
    background: white;
    padding: 0 15px;
    font-weight: 600;
    color: #1c2d5a;
}

.form-control-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    display: block;
}

.form-control {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 10px 12px;
    transition: all 0.2s;
    height: 42px;
}

.form-control:disabled {
    background-color: #f8f9fa;
    opacity: 0.8;
}

.coord-card {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
    transition: all 0.3s;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.coord-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.coord-header {
    background-color: #f1f5f9;
    padding: 12px 15px;
    font-weight: 600;
    color: #1c2d5a;
    border-bottom: 1px solid #e9ecef;
}

.coord-header i {
    margin-right: 8px;
}

.coord-body {
    padding: 15px;
}

.modal-footer {
    border-top: 1px solid #e9ecef;
    padding: 20px;
    display: flex;
    justify-content: flex-end;
}

.update-btn {
    padding: 12px 30px;
    font-weight: 600;
    border-radius: 6px;
    transition: all 0.3s;
    background-color: #1c2d5a;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.update-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(28, 45, 90, 0.2);
}

.input-highlight label {
    font-weight: 600;
    color: #1c2d5a;
}

.row {
    margin-left: -10px;
    margin-right: -10px;
}

.col-md-2, .col-md-3, .col-md-4, .col-md-6 {
    padding-left: 10px;
    padding-right: 10px;
}

.mb-4 {
    margin-bottom: 1.5rem;
}

.mr-1 {
    margin-right: 0.25rem;
}

.mr-2 {
    margin-right: 0.5rem;
}
</style>